import { AppBar, Container } from "@mui/material";
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../assets/Icons/index.js";
import PrimaryButton from "../../components/_utils/CommonButtons/PrimaryButton";
import ProfileQuickMenu from "../../containers/ProfileQuickMenu/index.jsx";
import {
  setCurrentMenu,
  setCurrentMenum,
} from "../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { IntervalConfiguration } from "../../utils/configurationProvider.js";
import PrimaryWithIconButton from "../_utils/CommonButtons/PrimaryWithIconButton/index.jsx";
import CustomizedBreadcrumbs from "./CustomizedBreadcrumbs";
import "./index.css";
import NavbarMenuPopover from "./NavbarMenuPopover";
import MobileViewPopover from "./NavbarMenuPopover/MobileViewPopover";

const STORAGE_KEY = "app_breadcrumb_by_idx";

const uuidPattern =
  /\b(?:[a-fA-F\d]{8}-[a-fA-F\d]{4}-[a-fA-F\d]{4}-[a-fA-F\d]{4}-[a-fA-F\d]{12}|\d+)\b/;

const containsNumberAndUppercase = /(?=.*\d)(?=.*[A-Z])/;

const ROOT_URLS = [
  "/home",
  "/settings",
  "/feature_not_assigned",
  "/beneficiary_account_dashboard",
  "/beneficiary_transaction_dashboard",
  "/owner_account_dashboard",
  "/internal_account_dashboard",
  "/internal_transaction_dashboard",
  "/reimbursement_account_dashboard",
  "/reimbursement_transaction_dashboard",
  "/private_transaction_dashboard",
  "/field_force_account_dashboard",
  "/field_force_transaction_dashboard",
  "/tax_account_dashboard",
  "/tax_transaction_dashboard",
  "/remitter_account_dashboard",
];

const appBarPathsArr = [
  "/home",
  "/beneficiary_account_dashboard",
  "/beneficiary_transaction_dashboard",
  "/owner_account_dashboard",
  "/internal_account_dashboard",
  "/internal_transaction_dashboard",
  "/reimbursement_account_dashboard",
  "/reimbursement_transaction_dashboard",
  "/private_transaction_dashboard",
  "/field_force_account_dashboard",
  "/field_force_transaction_dashboard",
  "/tax_account_dashboard",
  "/tax_transaction_dashboard",
  "/remitter_account_dashboard",
];

const pagesm = ["Home", "Transactions", "Accounts", "Profile"];

const initial = [
  {
    title: "",
    menuItems: [
      {
        icon: "",
        label: "",
        labelm: "",
        labela: "",
        route: "",
        menu: "",
      },
    ],
  },
];

const transactions = [
  {
    title: "Transactions",
    menuItems: [
      {
        icon: ICONS?.BENEFICIARY_TRANSACTION_BLUE_CIRCLE,
        label: "Beneficiary Transactions",
        labelm: "Beneficiary",
        labela: "Transactions",
        route: "beneficiary_transaction_dashboard",
        menu: "Transactions",
      },
      {
        icon: ICONS?.INTERNAL_TRANSACTION_BLUE_CIRCLE,
        label: "Internal Transactions",
        labelm: "Internal",
        labela: "Transactions",
        route: "internal_transaction_dashboard",
        menu: "Transactions",
      },
      // {
      //   icon: ICONS?.REIMBURSEMENT_TRANSACTION_BLUE_CIRCLE,
      //   label: "Reimbursement Transactions",
      //   labelm: "Reimbursement",
      //   labela: "Transactions",
      //   route: "reimbursement_transaction_dashboard",
      //   menu: "Transactions",
      // },
      // {
      //   icon: ICONS?.FIELD_FORCE_TRANSACTION_BLUE_CIRCLE,
      //   label: "Field Force Transactions",
      //   labelm: "Field Force",
      //   labela: "Transactions",
      //   route: "field_force_transaction_dashboard",
      //   menu: "Transactions",
      // },
      // {
      //   icon: ICONS?.PRIVATE_TRANSACTION_BLUE_CIRCLE,
      //   label: "Private Transactions",
      //   labelm: "Private",
      //   labela: "Transactions",
      //   route: "private_transaction_dashboard",
      //   menu: "Transactions",
      // },
      // {
      //   icon: ICONS?.TAX_TRANSACTION_WITH_BLUE_CIRCLE,
      //   label: "Tax Transactions",
      //   labelm: "Tax",
      //   labela: "Transactions",
      //   route: "tax_transaction_dashboard",
      //   menu: "Transactions",
      // },
    ],
  },
];

const accounts = [
  {
    title: "Accounts",
    menuItems: [
      {
        icon: ICONS?.BENEFICIARY_ACCOUNT_WITH_BLUE_CIRCLE,
        label: "Beneficiary Accounts",
        labelm: "Beneficiary",
        labela: "Accounts",
        route: "beneficiary_account_dashboard",
        menu: "Accounts",
      },
      {
        icon: ICONS?.OWNER_ACCOUNT_WITH_BLUE_CIRCLE,
        label: "Owner Accounts",
        labelm: "Owner",
        labela: "Accounts",
        route: "owner_account_dashboard",
        menu: "Accounts",
      },
      {
        icon: ICONS?.INTERNAL_ACCOUNT_WITH_BLUE_CIRCLE,
        label: "Internal Accounts",
        labelm: "Internal",
        labela: "Accounts",
        route: "internal_account_dashboard",
        menu: "Accounts",
      },
      // {
      //   icon: ICONS?.REIMBURSEMENT_ACCOUNT_WITH_BLUE_CIRCLE,
      //   label: "Reimbursement Accounts",
      //   labelm: "Reimbursement",
      //   labela: "Accounts",
      //   route: "reimbursement_account_dashboard",
      //   menu: "Accounts",
      // },
      // {
      //   icon: ICONS?.FIELD_FORCE_ACCOUNT_WITH_BLUE_CIRCLE,
      //   label: "Field Force Accounts",
      //   labelm: "Field Force",
      //   labela: "Accounts",
      //   route: "field_force_account_dashboard",
      //   menu: "Accounts",
      // },
      // {
      //   icon: ICONS?.TAX_ACCOUNT_WITH_BLUE_CIRCLE,
      //   label: "Tax Accounts",
      //   labelm: "Tax",
      //   labela: "Accounts",
      //   route: "tax_account_dashboard",
      //   menu: "Accounts",
      // },
      // {
      //   icon: ICONS?.REMITTER_ACCOUNT_WITH_BLUE_CIRCLE,
      //   label: "Remitter Accounts",
      //   labelm: "Remitter",
      //   labela: "Accounts",
      //   route: "remitter_account_dashboard",
      //   menu: "Accounts",
      // },
    ],
  },
];

function ResponsiveAppBar({ type }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const appBarRef = useRef(null);
  const profileRef = useRef(null);
  const deepHandledRef = useRef(false);
  const navigationLockRef = useRef(false);
  const [zIndex, setZIndex] = useState(7);
  const [isMobile, setIsMobile] = useState(false);
  const [shrinkStart, setShrinkStart] = useState(null);
  const [openPopover, setOpenPopover] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [currentPage, setCurrentPage] = useState("Home");
  const [rightPosition, setRightPosition] = useState("10%");
  const [breadcrumbStack, setBreadcrumbStack] = useState([]);
  const [animatingIndex, setAnimatingIndex] = useState(null);
  const [openMobilePopover, setOpenMobilePopover] = useState(false);
  const [arrowUp, setArrowUp] = useState({
    Transactions: false,
    Accounts: false,
    Home: true,
  });
  const [arrowUpm, setArrowUpm] = useState({
    Transactions: false,
    Accounts: false,
    Home: true,
    Profile: false,
  });

  const hideBreadCrumb = useSelector((state) => state.hideBreadCrumb.hide);
  const currentmenu = useSelector((state) => state.hideBreadCrumb.menu);

  const collapsedBreadcrumbs = useMemo(() => {
    if (breadcrumbStack.length <= 2) return breadcrumbStack;

    return [
      { label: "...", fullPath: "__collapsed__" }, // Ellipsis at start
      breadcrumbStack[breadcrumbStack.length - 2], // Second last
      breadcrumbStack[breadcrumbStack.length - 1], // Last
    ];
  }, [breadcrumbStack]);

  /* ---------------- HIDDEN BREADCRUMBS (FOR HOVER BOX) ---------------- */

  const hiddenBreadcrumbs = useMemo(() => {
    if (breadcrumbStack.length <= 2) return [];

    return breadcrumbStack.slice(0, breadcrumbStack.length - 2);
    // everything before last 2
  }, [breadcrumbStack]);

  /* ---------------- SESSION HELPERS ---------------- */

  const getSession = () => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  };

  const setSession = (data) => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  };

  /* ---------------- CLEAN PARTS ---------------- */

  // useMemo
  const cleanParts = useMemo(() => {
    if (!location.pathname) return [];
    return location.pathname.split("/").filter(Boolean);
  }, [location.pathname]);

  /* ---------------- BUILD STACK ---------------- */

  const buildStackFromParts = useCallback((parts) => {
    let builtPath = "";
    const stack = [];

    parts.forEach((part) => {
      builtPath += `/${part}`;

      const isUUID =
        uuidPattern.test(part) || containsNumberAndUppercase.test(part);

      if (isUUID) {
        if (stack.length) stack[stack.length - 1].fullPath = builtPath;
      } else {
        stack.push({
          label: part,
          fullPath: builtPath,
        });
      }
    });

    return stack;
  }, []);

  /* ---------------- MAIN EFFECT ---------------- */

  const handleClick = () => {
    setZIndex((prevZIndex) => (prevZIndex === 8 ? 7 : 7));
  };

  // useLayoutEffect
  useLayoutEffect(() => {
    const idx = window.history.state?.idx ?? 0;

    if (!cleanParts.length) {
      setBreadcrumbStack([]);
      return;
    }

    const fullPath = location.pathname;
    const parsed = getSession();

    /* ---------------- DEEP LOGIN ---------------- */

    const isDeepLogin =
      idx === 0 && cleanParts.length > 1 && !deepHandledRef.current;

    if (isDeepLogin) {
      deepHandledRef.current = true;

      let builtPath = "";
      let tempStack = [];
      let historyIndex = 0;
      const newHistoryMap = {};

      cleanParts.forEach((part) => {
        builtPath += `/${part}`;

        const isUUID =
          uuidPattern.test(part) || containsNumberAndUppercase.test(part);

        if (!isUUID) {
          tempStack = [...tempStack, { label: part, fullPath: builtPath }];
          newHistoryMap[historyIndex++] = [...tempStack];
        } else if (tempStack.length) {
          tempStack[tempStack.length - 1].fullPath = builtPath;
          newHistoryMap[historyIndex - 1] = [...tempStack];
        }
      });

      sessionStorage.removeItem(STORAGE_KEY);
      setSession(newHistoryMap);

      const paths = Object.values(newHistoryMap).map(
        (stack) => stack[stack.length - 1].fullPath,
      );

      navigate(paths[0], { replace: true });

      setTimeout(() => {
        paths.slice(1).forEach((p) => navigate(p));
      }, 0);

      return;
    }

    /* ---------------- NORMAL NAVIGATION ---------------- */

    const isRootUrl = ROOT_URLS.includes(fullPath);

    let newStack;

    if (isRootUrl) {
      newStack = buildStackFromParts(cleanParts);
    } else {
      const previousIdx = idx - 1;
      const previousStack = parsed[previousIdx];
      const currentBuilt = buildStackFromParts(cleanParts);

      if (previousStack?.length) {
        const statusKeywords = ["success", "pending", "failed", "error"];

        const containsStatus = previousStack.some((crumb) =>
          statusKeywords.some((status) =>
            crumb.label.toLowerCase().includes(status),
          ),
        );

        if (containsStatus) {
          const rootCrumb = previousStack[0];
          const lastCrumb = currentBuilt[currentBuilt.length - 1];
          newStack = rootCrumb ? [rootCrumb, lastCrumb] : currentBuilt;
        } else {
          const lastCrumb = currentBuilt[currentBuilt.length - 1];

          const existingIndex = previousStack.findIndex(
            (c) => c.fullPath === lastCrumb.fullPath,
          );

          newStack =
            existingIndex !== -1
              ? [...previousStack.slice(0, existingIndex), lastCrumb]
              : [...previousStack, lastCrumb];
        }
      } else {
        newStack = currentBuilt;
      }
    }

    /* ---------------- CLEAN FORWARD HISTORY ---------------- */

    if (!deepHandledRef.current) {
      Object.keys(parsed).forEach((key) => {
        if (Number(key) > idx) delete parsed[key];
      });
    }

    parsed[idx] = newStack;
    setSession(parsed);

    setBreadcrumbStack(newStack);

    setAnimatingIndex(newStack.length - 1);

    const timer = setTimeout(
      () => setAnimatingIndex(null),
      IntervalConfiguration?.intervalSmall || 300,
    );

    return () => clearTimeout(timer);
  }, [
    location.pathname,
    location.key,
    cleanParts,
    buildStackFromParts,
    navigate,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (appBarRef.current && !appBarRef.current.contains(event.target)) {
        setOpenPopover(false);
        setOpenMobilePopover(false);
        setArrowUp({
          Transactions: false,
          Accounts: false,
          Home: false,
        });
        setArrowUpm({
          Transactions: false,
          Accounts: false,
          Home: false,
          Profile: false,
        });
      }
      setZIndex((prevZIndex) => (prevZIndex === 8 ? 7 : 7));
    };

    document.addEventListener("mousedown", handleClickOutside);

    if (openMobilePopover) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [appBarRef, openMobilePopover]);

  useEffect(() => {
    if (arrowUp.Transactions || arrowUp.Accounts) {
      setOpenPopover(true);
    } else {
      setOpenPopover(false);
    }
  }, [arrowUp.Transactions, arrowUp.Accounts]);

  useEffect(() => {
    if (arrowUpm.Transactions || arrowUpm.Accounts) {
      setOpenMobilePopover(true);
    } else {
      setOpenMobilePopover(false);
    }
  }, [arrowUpm]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setIsMobile(window.innerWidth < 801);

      if (width >= 3840 && height >= 1920) {
        setRightPosition("34%");
      } else if (width >= 2560 && height >= 1440) {
        setRightPosition("26%");
      } else if (width >= 2560 && height >= 1330) {
        setRightPosition("26%");
      } else {
        setRightPosition("10%");
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (openPopover) return;

    let menu = location.pathname.split("/")[1];

    if (
      [
        "beneficiary_account_dashboard",
        "internal_account_dashboard",
        "owner_account_dashboard",
        "reimbursement_account_dashboard",
        "tax_account_dashboard",
        "field_force_account_dashboard",
        "remitter_account_dashboard",
        "accounts",
      ].includes(menu)
    ) {
      dispatch(setCurrentMenu("Accounts"));
      setCurrentPage("Accounts");
    } else if (
      [
        "transaction",
        "beneficiary_transaction_dashboard",
        "internal_transaction_dashboard",
        "reimbursement_transaction_dashboard",
        "private_transaction_dashboard",
        "tax_transaction_dashboard",
        "field_force_transaction_dashboard",
      ].includes(menu)
    ) {
      dispatch(setCurrentMenu("Transactions"));
      setCurrentPage("Transactions");
    } else {
      dispatch(setCurrentMenu("Home"));
      setCurrentPage("Home");
    }
  }, [dispatch, location.pathname, openPopover]);

  //For Profile Component
  useEffect(() => {
    function handleClickOutside(event) {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setOpenProfile(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeTopNav = () => {
    setArrowUp({
      Transactions: false,
      Accounts: false,
      Home: true,
    });
  };

  const handleMenuItemClick = (route, page) => {
    closeTopNav();
    setCurrentPage(page);
    navigate(route);
  };

  return (
    <>
      {!isMobile && (
        <>
          <div
            ref={appBarRef}
            className={`fixed h-auto w-width-full bg-text-primary z-z-index-fixed-ui rounded-t-none top-top-base ${!hideBreadCrumb && !openPopover ? "rounded-b-none" : "rounded-b-border-radius-md shadow-box-shadow-bottom"}`}
          >
            <div className="flex flex-col items-center w-width-full relative">
              <div
                className="h-height-full flex flex-row items-center max-w-tab-width-normal w-width-full justify-between py-padding-sm md:px-padding-md lg:px-padding-base relative z-z-index-header"
                onClick={() => {
                  if (openPopover) {
                    setOpenPopover(false);
                    setArrowUp({
                      Transactions: false,
                      Accounts: false,
                      Home: false,
                    });
                  }
                }}
              >
                {/* Xpentra Icon */}
                <img
                  src={
                    "https://q2pay.in/new_assets/xpentra_logo/xpentra_blue.svg"
                  }
                  className="w-xpentra-logo-width h-xpentra-logo-height cursor-pointer"
                  alt="XpentraLogo"
                  onClick={() => {
                    navigate("/home");
                    dispatch(setCurrentMenu("Home"));
                  }}
                />
                <div className="flex flex-row gap-x-gap-xl">
                  {/* Home button */}
                  <PrimaryButton
                    btnText={"Home"}
                    btnType="button"
                    handleFunction={(e) => {
                      setCurrentPage("Home");
                      dispatch(setCurrentMenu("Home"));
                      setArrowUp({
                        Transactions: false,
                        Accounts: false,
                      });
                      navigate("/home");
                    }}
                    isDisabled={false}
                    enabledTextColor={
                      currentPage === "Home"
                        ? "var(--text-primary)"
                        : "var(--primary-bg)"
                    }
                    enabledBgColor={
                      currentPage === "Home"
                        ? "var(--primary-bg)"
                        : "var(--text-primary)"
                    }
                    isLoading={false}
                    hoverOption={currentPage === "Home" ? "black" : "blue"}
                    fullWidthRequired={false}
                  />
                  {/* Transactions button */}
                  <PrimaryWithIconButton
                    btnText={"Transactions"}
                    btnType="button"
                    handleFunction={(e) => {
                      e.stopPropagation();
                      setCurrentPage("Transactions");
                      e.preventDefault();
                      setArrowUp((prev) => ({
                        ...prev,
                        Transactions: !prev.Transactions,
                        Accounts: false,
                      }));
                    }}
                    isDisabled={false}
                    enabledTextColor={
                      currentPage === "Transactions"
                        ? "var(--text-primary)"
                        : "var(--primary-bg)"
                    }
                    enabledBgColor={
                      currentPage === "Transactions"
                        ? "var(--primary-bg)"
                        : "var(--text-primary)"
                    }
                    isLoading={false}
                    icon={
                      openPopover && currentPage === "Transactions"
                        ? "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                        : "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                    }
                    iconToBeAlign="right"
                    hoverOption={
                      currentPage === "Transactions" ? "black" : "blue"
                    }
                    fullWidthRequired={false}
                    imgColor={
                      currentPage === "Transactions"
                        ? "var(--text-primary)"
                        : "var(--primary-bg)"
                    }
                    isAppBar={true}
                  />
                  {/* Accounts button */}
                  <PrimaryWithIconButton
                    btnText={"Accounts"}
                    btnType="button"
                    handleFunction={(e) => {
                      e.stopPropagation();
                      setCurrentPage("Accounts");
                      e.preventDefault();
                      setArrowUp((prev) => ({
                        ...prev,
                        Accounts: !prev.Accounts,
                        Transactions: false,
                      }));
                    }}
                    isDisabled={false}
                    enabledTextColor={
                      currentPage === "Accounts"
                        ? "var(--text-primary)"
                        : "var(--primary-bg)"
                    }
                    enabledBgColor={
                      currentPage === "Accounts"
                        ? "var(--primary-bg)"
                        : "var(--text-primary)"
                    }
                    isLoading={false}
                    icon={
                      openPopover && currentPage === "Accounts"
                        ? "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                        : "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                    }
                    iconToBeAlign="right"
                    hoverOption={currentPage === "Accounts" ? "black" : "blue"}
                    fullWidthRequired={false}
                    imgColor={
                      currentPage === "Accounts"
                        ? "var(--text-primary)"
                        : "var(--primary-bg)"
                    }
                    isAppBar={true}
                  />
                </div>

                {/* Profile Icon */}
                <div
                  className="SettingAndNotifications relative inline-block"
                  onClick={() => setOpenProfile(!openProfile)}
                >
                  <img
                    src={
                      "https://q2pay.in/new_assets/common/settings/profile_icon_of_navigationbar.svg"
                    }
                    alt="Profile"
                    className="transition-transform duration-animation-fast ease-in-out cursor-pointer"
                    style={{
                      width: "var(--icon-lg)",
                      height: "var(--icon-lg)",
                      zIndex: "var(--base-opacity)",
                    }}
                  />
                  <div
                    ref={profileRef}
                    className={`absolute overflow-hidden h-auto left-auto top-top-base right-right-base z-z-index-fixed-ui bg-primary-bg rounded-border-radius-md shadow-box-shadow-bottom ${openProfile ? "scale-100 opacity-base-opacity" : "scale-0 opacity-opacity-none"}`} // tailwind class scale has been used
                    style={{
                      transformOrigin:
                        "calc(var(--right-full) - var(--gap-sm)) var(--gap-sm)", //right full represents 100% & gap-sm represents 10px
                      transition:
                        "transform var(--animation-fast) ease-in-out, opacity var(--animation-fast) ease-in-out",
                    }}
                  >
                    <ProfileQuickMenu
                      openProfile={openProfile}
                      setOpenProfile={setOpenProfile}
                    />
                  </div>
                </div>
              </div>

              <div
                className={`absolute bottom-bottom-base w-width-full transition-all duration-animation-fast delay-[var(--animation-fast)] bg-text-primary py-padding-sm z-z-index-base ${openPopover ? "rounded-b-none" : "rounded-b-border-radius-md"}`}
              ></div>

              <div
                style={{
                  display:
                    openPopover || (!hideBreadCrumb && !openPopover)
                      ? "block"
                      : "none",
                }}
                className={`relative z-z-index-content max-w-tab-width-normal w-slider-items-seperator-line-width lg:w-width-full Qmd:mx-margin-md Qlg:mx-margin-base border-b-borderthickness border-solid border-text-secondary`}
              ></div>
            </div>

            <div
              className={`${hideBreadCrumb ? "" : "hidden md:block relative"}`}
            >
              {!hideBreadCrumb && !openPopover && (
                <>
                  <div className="w-width-full h-breadcrumb-height rounded-b-border-radius-md bg-text-primary py-padding-sm Qsmd:px-padding-md xl:px-padding-base top-top-base absolute shadow-box-shadow-bottom">
                    <CustomizedBreadcrumbs
                      navigationLockRef={navigationLockRef}
                      setShrinkStart={setShrinkStart}
                      getSession={getSession}
                      breadcrumbStack={breadcrumbStack}
                      animatingIndex={animatingIndex}
                      shrinkStart={shrinkStart}
                      hiddenBreadcrumbs={hiddenBreadcrumbs}
                      collapsedBreadcrumbs={collapsedBreadcrumbs}
                    />
                  </div>
                </>
              )}
              <NavbarMenuPopover
                open={openPopover}
                setOpenPopover={setOpenPopover}
                setArrowUp={setArrowUp}
                type={
                  arrowUp["Transactions"]
                    ? "transactions"
                    : arrowUp["Accounts"]
                      ? "accounts"
                      : "initial"
                }
                data={
                  arrowUp["Transactions"]
                    ? transactions
                    : arrowUp["Accounts"]
                      ? accounts
                      : initial
                }
                handleMenuItemClick={handleMenuItemClick}
              />
            </div>
          </div>
        </>
      )}

      {/* Responsive Part */}
      {isMobile &&
        !window.location.pathname.includes("/feature_not_assigned") && (
          <>
            <AppBar
              ref={appBarRef}
              style={{
                background: "var(--primary-nav)",
                height: "auto",
                borderRadius:
                  "var(--border-radius-md) var(--border-radius-md) var(--border-none) var(--border-none)",
                top: "auto",
                bottom: "var(--bottom-base)",
                zIndex: zIndex,
                display: appBarPathsArr.includes(window.location.pathname)
                  ? "block"
                  : "none",
              }}
            >
              <Container
                className="mobilmenumain"
                style={{ display: "flex" }}
              >
                {pagesm.map((pagem) => (
                  <Link
                    key={pagem}
                    to={pagem === "Home" ? "/home" : "#"}
                    className="mobilmenu"
                  >
                    <div
                      onClick={() => {
                        if (pagem === "Home") {
                          dispatch(setCurrentMenum(pagem));
                        } else if (pagem === "Accounts") {
                          setArrowUpm({ Home: false });
                          setArrowUpm({ Transactions: false });
                          setArrowUpm({ Profile: false });
                          setArrowUpm({ [pagem]: !arrowUp[pagem] });
                          handleClick();
                        }
                        if (pagem === "Transactions") {
                          setArrowUpm({ Home: false });
                          setArrowUpm({ Accounts: false });
                          setArrowUpm({ Profile: false });
                          setArrowUpm({ [pagem]: !arrowUp[pagem] });
                          handleClick();
                        }

                        if (pagem === "Profile") {
                          navigate("/home/profile_quick_menu");
                        }
                      }}
                    >
                      {pagem === "Home" ? (
                        pagem === currentmenu ? (
                          <img
                            className="w-icon-lg"
                            src={
                              "https://q2pay.in/new_assets/common/dashboard/home_selected.svg"
                            }
                            alt="home_selected"
                            style={{ margin: "var(--margin-xs) auto" }}
                          />
                        ) : (
                          <img
                            className="w-icon-lg"
                            src={
                              "https://q2pay.in/new_assets/common/dashboard/home_unselected.svg"
                            }
                            alt="home_unselected"
                            style={{ margin: "var(--margin-xs) auto" }}
                          />
                        )
                      ) : null}
                      {pagem === "Transactions" ? (
                        pagem === currentmenu ? (
                          <img
                            className="w-icon-lg"
                            src={
                              "https://q2pay.in/new_assets/common/dashboard/transaction_selected.svg"
                            }
                            alt="transaction_selected"
                            style={{ margin: "var(--margin-xs) auto" }}
                          />
                        ) : (
                          <img
                            className="w-icon-lg"
                            src={
                              "https://q2pay.in/new_assets/common/dashboard/transaction_unselected.svg"
                            }
                            alt="transaction_unselected"
                            style={{ margin: "var(--margin-xs) auto" }}
                          />
                        )
                      ) : null}
                      {pagem === "Accounts" ? (
                        pagem === currentmenu ? (
                          <img
                            className="w-icon-lg"
                            src={
                              "https://q2pay.in/new_assets/common/dashboard/account_selected.svg"
                            }
                            alt="account_selected"
                            style={{ margin: "var(--margin-xs) auto" }}
                          />
                        ) : (
                          <img
                            className="w-icon-lg"
                            src={
                              "https://q2pay.in/new_assets/common/dashboard/account_unselected.svg"
                            }
                            alt="account_unselected"
                            style={{ margin: "var(--margin-xs) auto" }}
                          />
                        )
                      ) : null}
                      {pagem === "Profile" ? (
                        pagem === currentmenu ? (
                          <img
                            className="w-icon-lg"
                            src={
                              "https://q2pay.in/new_assets/common/others/profile_selected.svg"
                            }
                            alt="profile_selected"
                            style={{ margin: "var(--margin-xs) auto" }}
                          />
                        ) : (
                          <img
                            className="w-icon-lg"
                            src={
                              "https://q2pay.in/new_assets/common/create_flow/profile_unselected.svg"
                            }
                            alt="profile_unselected"
                            style={{ margin: "var(--margin-xs) auto" }}
                          />
                        )
                      ) : null}
                      {pagem}
                      {pagem === "Transactions" || pagem === "Accounts" ? (
                        arrowUpm[pagem] ? (
                          <></>
                        ) : (
                          <></>
                        )
                      ) : null}
                    </div>
                  </Link>
                ))}
              </Container>
              <div className="mobilePopover">
                {openMobilePopover ? (
                  <MobileViewPopover
                    open={openMobilePopover}
                    setOpenMobilePopover={setOpenMobilePopover}
                    setArrowUpm={setArrowUpm}
                    data={arrowUpm["Transactions"] ? transactions : accounts}
                  />
                ) : null}
              </div>
            </AppBar>
          </>
        )}
    </>
  );
}
export default ResponsiveAppBar;
